'use strict';

require('./cn-head-action.scss');

module.exports = {
  template: require('./cn-head-action.html'),
  controller: require('./cn-head-action.controller'),
  controllerAs: 'vm',
  transclude: true,

  require: {
    parentController: '^^cnHead'
  },

  bindings: {
    'do': '&',
    icon: '@',
    text: '@',
    href: '@',
    buttonClass: '@'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-head/cn-head-action/index.js
 ** module id = 37
 ** module chunks = 0
 **/